import { Controller } from "stimulus";
import Gauge from "svg-gauge";

export default class extends Controller {

    initialize() {
        this.element.addEventListener('gauge:set-value', (event) => {
            this.setValue(event.detail.value || 0, event.detail.duration);
        });
    }

    connect() {
        this.gauge = this.gauge || Gauge(this.element, {
            min: this.data.get('min') || 0,
            max: this.data.get('max') || 100,
            label: value => this.getLabel(value),
            color: function (value){
              if(value >= 70){
                return 'rgb(98 199 41)'
              }
              if(value < 30){
                return 'rgb(223 56 44)'
              }
              return 'rgb(255 204 0)'

            }
        });
        this.gauge.setValue(this.data.get('value') || 0);
    }

    getLabel(value) {
        return this.data.get('value-prefix') + value + this.data.get('value-postfix');
    }


    setValue(value, duration = 200) {
        const start_value = this.gauge.getValue();
        const diff = value - start_value;
        clearInterval(this.interval);
        if (diff === 0 || duration === 0) {
            this.gauge.setValue(value);
            return;
        }
        let step = 0;
        let steps = Math.ceil(duration / 33);
        this.interval = setInterval(() => {
            this.gauge.setValue(Math.round(start_value + (++step / steps * diff)));
            if (step === steps) clearInterval(this.interval);
        }, 33);
    }
}
